import { API_BASE_URL } from "../config/api";

/**
 * Resolve API-stored paths for <img src> when the SPA runs on a different origin/port
 * than the backend (e.g. React on :3001, API on :3000).
 *
 * Handles: data URLs, http(s), absolute paths starting with "/", and bare filenames.
 * For bare filenames (no "/"), pass subfolder e.g. "users" -> /uploads/users/name.jpg
 */
export function resolveApiUploadUrl(path, bareNameSubfolder) {
  if (path == null || path === "") return null;
  const p = String(path).trim();
  if (!p) return null;
  if (p.startsWith("data:") || p.startsWith("http")) return p;
  if (p.startsWith("/")) return `${API_BASE_URL}${p}`;
  if (bareNameSubfolder) {
    const sub = String(bareNameSubfolder).replace(/^\/|\/$/g, "");
    return `${API_BASE_URL}/uploads/${sub}/${p}`;
  }
  return `${API_BASE_URL}/uploads/${p}`;
}
